<template>
  <section>
    {{ addEventPixeleFacebook() }}
    <navbar-public></navbar-public>
    <section class="ew-smaller-container ew-mb">
      <h1 class="ew-section-header ew-section-header--no-margin">Preguntas frecuentes</h1>

      <div class="ew-faq-item" v-for="(q, i) in questions" :key="i">
        <p class="ew-faq-item__question">{{ q.question }}</p>
        <p class="ew-faq-item__answer" v-html="q.answer"></p>
      </div>
    </section>

    <footer-public></footer-public>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import NavbarPublic from './Header/NavbarPublic'
import FooterPublic from './Header/FooterPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'FrequentQuestions',
  data () {
    return {
      questions: [
        {
          question: '¿Por qué elegir el portal enviosweb.mx para hacer tus envíos y no hacerlo directamente con la paquetería?',
          answer: 'Al cotizar aquí accedes a tarifas muy ventajosas gracias al gran volumen de envíos de la plataforma, y puedes elegir entre las mejores paqueterías del país.'
        },
        {
          question: '¿Cuáles son los factores que determinan el costo del paquete?',
          answer: 'El costo de la guía se determina por el peso en KG y peso volumétrico, al realizar el cálculo el resultado mayor es el que se toma en cuenta <strong>(Peso volumétrico = Lado x Lado x Lado / 5000).</strong>'
        },
        {
          question: '¿Qué pasa si me excedo del peso indicado en la guía?',
          answer: 'Se generan multas por kg excedido, las cuales le llegará como notificación a su correo electrónico, el paquete se retendrá en almacén hasta que se salde el total de la deuda.'
        },
        {
          question: '¿Quién pasará a recoger los paquetes y quién los entregará?',
          answer: 'La paquetería de su elección, recolectarán y entregarán en la dirección que usted indique en la guía.'
        }
      ]
    }
  },
  watch: {},
  methods: {
    addEventPixeleFacebook(){
      fbq('track', 'ViewContent');
    }
  },
  computed: {},
  created () {},
  components: {
    'navbar-public': NavbarPublic,
    'footer-public': FooterPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 760px; margin: 0 auto; }
.ew-mb { margin-bottom: 5rem; }

.ew-faq-item {
  @include ew-card;
  padding: 1.5rem 1.75rem;
  margin-bottom: 1rem;
}

.ew-faq-item__question {
  font-family: var(--app-font);
  font-size: 1rem;
  font-weight: 700;
  color: var(--app-navy);
  margin-bottom: 0.5rem;
}

.ew-faq-item__answer {
  font-family: var(--app-font);
  font-size: 0.92rem;
  color: var(--app-navy-secondary);
  line-height: 1.6;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FrequentQuestions.vue